import { useEffect, useState } from "react";
import { getBirthdayMode, isBirthdaySeason } from "../config/constants/founderBirthday";

const PREVIEW_KEY = "arvix:birthday-preview";

// Reads `?birthday=preview|belated|off` once and remembers it for the tab, so
// the preview survives client-side navigation without the query string.
// Returns 'birthday', 'belated' or null.
const readPreviewMode = () => {
    try {
        const param = new URLSearchParams(window.location.search).get("birthday");
        if (param === "preview") sessionStorage.setItem(PREVIEW_KEY, "birthday");
        else if (param === "belated") sessionStorage.setItem(PREVIEW_KEY, "belated");
        else if (param === "off") sessionStorage.removeItem(PREVIEW_KEY);
        const stored = sessionStorage.getItem(PREVIEW_KEY);
        // Backwards compatible with the old "1" flag, which meant the 23rd.
        if (stored === "1" || stored === "birthday") return "birthday";
        if (stored === "belated") return "belated";
        return null;
    } catch {
        return null;
    }
};

const getModeNow = () => readPreviewMode() || getBirthdayMode();

const isActiveNow = () => readPreviewMode() !== null || isBirthdaySeason();

// True across 23–24 September (Bangladesh time). Re-checks every minute so
// a tab left open switches on at midnight and off when the window ends.
const useFounderBirthday = () => {
    const [active, setActive] = useState(isActiveNow);

    useEffect(() => {
        const timer = setInterval(() => setActive(isActiveNow()), 60 * 1000);
        return () => clearInterval(timer);
    }, []);

    return active;
};

// 'birthday' on the 23rd, 'belated' on the 24th, null outside the window.
// `?birthday=preview` forces birthday, `?birthday=belated` forces belated.
export const useBirthdayMode = () => {
    const [mode, setMode] = useState(getModeNow);

    useEffect(() => {
        const timer = setInterval(() => setMode(getModeNow()), 60 * 1000);
        return () => clearInterval(timer);
    }, []);

    return mode;
};

export default useFounderBirthday;
